// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 9720) return "static/chunks/9720-7ae865788225ffa1.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"4928":"87e745433f461059","6514":"a30c56f1b0d2cff1"}[chunkId] + ".js";
};